export default __webpack_public_path__ + "static/media/Mastercard Logo2.ae31f594.png";